import React, {useState} from 'react';
import Audit from "../components/Audit";
import AiKillSwitch from "../components/AiKillSwitch";
import KpiDashboard from "../components/KpiDashboard";
import AdminSubscriptions from "../components/AdminSubscriptions";
import StylistAdmin from "../components/StylistAdmin";
import {useDocumentTitle} from '../hooks/useDocumentTitle';

const AdminPanel: React.FC = () => {
    useDocumentTitle();
    const [activeTab, setActiveTab] = useState('audit');

    const tabs = [
        {
            key: 'audit',
            label: 'Audit',
            content: <Audit/>
        },
        {
            key: 'ai',
            label: 'AI',
            content: <AiKillSwitch/>
        },
        {
            key: 'kpi',
            label: 'KPI',
            content: <KpiDashboard/>
        },
        {
            key: 'subscriptions',
            label: 'Подписки',
            content: <AdminSubscriptions/>
        },
        {
            key: 'stylist',
            label: 'Стилист',
            content: <StylistAdmin/>
        }
    ];

    return (
        <div className="space-y-6" data-testid="admin-panel">
            <div className="text-center">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
                    Панель администратора
                </h1>
                <p className="text-lg text-gray-600 dark:text-gray-400 mt-2">
                    Управление системой и мониторинг
                </p>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200 dark:border-gray-700">
                <nav aria-label="Разделы админ-панели" data-testid="admin-tabs" className="-mb-px flex space-x-8">
                    {tabs.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            data-testid={`admin-tab-${tab.key}`}
                            aria-current={activeTab === tab.key ? 'page' : undefined}
                            onClick={() => setActiveTab(tab.key)}
                            className={`py-2 px-1 border-b-2 font-medium text-sm ${
                                activeTab === tab.key
                                    ? 'border-primary-500 text-primary-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </nav>
            </div>

            {/* Tab Content */}
            <div className="mt-6" data-testid="admin-tab-content">
                {tabs.find(tab => tab.key === activeTab)?.content}
            </div>
        </div>
    );
};

export default AdminPanel;
